export const CALENDLY_URL = 'https://calendly.com/pegasusux/uiconsultation';

// Fires the Google Ads "Contact" click conversion. These links open in a new
// tab, so the current page never unloads, no need to delay navigation the
// way Google's snippet does for same-tab links.
export function trackContactClick() {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'manual_event_CONTACT');
  }
}
